import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./componentes/Header";
import InicioAntifraude from "./componentes/InicioAntifraude";
import Footer from "./componentes/Footer";
import ConsultaTramite from "./componentes/ConsultaTramite";
import ConsultarExpediente from "./componentes/ConsultarExpediente";
import AdminPage from "./componentes/AdminPage";
import AvisoPrivacidad from "./componentes/AvisoPrivacidad";
import ModalProceso from "./componentes/ModalProceso";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
    background-color: #fafafa;
  }
`;

export default function App() {
  const [isConsultaOpen, setIsConsultaOpen] = useState(false);
  const [isProcesoOpen, setIsProcesoOpen] = useState(false);
  const [isExpedienteOpen, setIsExpedienteOpen] = useState(false);

  return (
    <Router>
      <GlobalStyle />
      <AvisoPrivacidad />
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <Header onConsultar={() => setIsConsultaOpen(true)} />
              <InicioAntifraude 
                onConsultar={() => setIsConsultaOpen(true)} 
                onComenzar={() => setIsProcesoOpen(true)}
                onConsultarExpediente={() => setIsExpedienteOpen(true)}
              />
              <Footer />
              <ConsultaTramite
                isOpen={isConsultaOpen}
                onClose={() => setIsConsultaOpen(false)}
              />
              <ConsultarExpediente
                isOpen={isExpedienteOpen}
                onClose={() => setIsExpedienteOpen(false)}
              />
              <ModalProceso
                isOpen={isProcesoOpen}
                onClose={() => setIsProcesoOpen(false)}
              />
            </>
          } 
        />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}
